
import { Vue, Component } from "vue-property-decorator";

@Component
export default class extends Vue {
  nativeModal: HTMLDialogElement | null = null;

  handleDialogClose(event: MouseEvent) {
    this.$refs.nativeModal!.close();

    event.stopPropagation();
    return false;
  }

  handleTipClick() {
    if (window.innerWidth > 1023) {
      return;
    }

    this.$refs.nativeModal!.showModal();
  }
}
